import React from 'react';
import Subtype from './components/SubtypeContent';

const Panel = props => (
  <Subtype {...props} />
);

export default Panel;
